import { mfRouteAddRouteParameter, mfRouteJoinRouteParts } from "@pattonair/material-framework";

export class AucRouteNames {
  public static readonly parameterNameAuctionId = "auctionId" as const;

  public static readonly partNameDetail = "detail" as const;
  public static readonly partNameList = "list" as const;
  public static readonly partNameAuctions = "auctions" as const;
  public static readonly partNameWon = "won" as const;
  public static readonly partNameHome = "home" as const;
  public static readonly partNameBids = "bids" as const;

  public static readonly partNameParameterAuctionDetailAuctionId = mfRouteAddRouteParameter(this.partNameDetail, [this.parameterNameAuctionId]);

  public static readonly routeHome = this.partNameHome;

  public static readonly routeAuctionsList = mfRouteJoinRouteParts([this.partNameAuctions, this.partNameList]);
  public static readonly routeWonList = mfRouteJoinRouteParts([this.partNameWon, this.partNameList]);
  public static readonly routeBidList = mfRouteJoinRouteParts([this.partNameBids, this.partNameList]);

  public static readonly routeAuctionDetail = mfRouteJoinRouteParts([this.partNameAuctions, this.partNameDetail]);

  public static readonly routeWonAuctionDetail = mfRouteJoinRouteParts([this.partNameWon, this.partNameDetail]);

  public static readonly routeBidAuctionDetail = mfRouteJoinRouteParts([this.partNameBids, this.partNameDetail]);

  public static getAuctionDetailRouteAuctionId = (auctionId: string) => mfRouteJoinRouteParts([this.routeAuctionDetail, auctionId.toString()]);
  public static getWonAuctionDetailRouteAuctionId = (auctionId: string) => mfRouteJoinRouteParts([this.routeWonAuctionDetail, auctionId.toString()]);
  public static getBidAuctionDetailRouteAuctionId = (auctionId: string) => mfRouteJoinRouteParts([this.routeBidAuctionDetail, auctionId.toString()]);
}
